import { musicManager } from "../managers/MusicManager";

export function wasSitup(setMemory) {
  setMemory((memory) => {
    const didSitup = Date.now() - memory["lastSitup"] > 500;
    if (didSitup) {
      musicManager.playPop();
    }
    return {
      ...memory,
      lastSitup: Date.now(),
      situps: didSitup ? memory["situps"] + 1 : memory["situps"],
    };
  });
}
